import { InsurancePolicyProviderType } from '@/shared/enums';
import { Providers } from '@/shared/Providers';
import { createRoot } from 'react-dom/client';
import { InsurancePolicyProviderDetailsModal } from './views/InsurancePolicyProviderDetailsModal';

type ShowInsurancePolicyProviderDetailsModalProps = {
    insurancePolicyProviderType: InsurancePolicyProviderType;
};

export const showInsurancePolicyProviderDetailsModal = ({
    insurancePolicyProviderType,
}: ShowInsurancePolicyProviderDetailsModalProps) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleClose = () => {
        root.unmount();
        container.remove();
    };

    root.render(
        <Providers>
            <InsurancePolicyProviderDetailsModal
                onClose={handleClose}
                insurancePolicyProviderType={insurancePolicyProviderType}
            />
        </Providers>,
    );
};
